import { render, staticRenderFns } from "./CardSlide.vue?vue&type=template&id=9d66230e&scoped=true&"
import script from "./CardSlide.vue?vue&type=script&lang=js&"
export * from "./CardSlide.vue?vue&type=script&lang=js&"
import style0 from "./CardSlide.vue?vue&type=style&index=0&id=9d66230e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d66230e",
  null
  
)

export default component.exports